import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowUpRight, Download } from "lucide-react";
import { toast } from "sonner";

const Spec = ({ k, v }) => (
  <div className="flex items-baseline justify-between border-b border-slate-200/80 py-2.5 text-sm">
    <span className="text-[var(--muted)]">{k}</span>
    <span className="font-semibold text-[var(--navy)]">{v}</span>
  </div>
);

export const ProductModal = ({ product, onClose }) => (
  <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="product-modal" className="max-w-4xl p-0 overflow-hidden rounded-[1.5rem] border-slate-200 bg-white" data-lenis-prevent>
      {product && (
        <div className="grid md:grid-cols-2">
          <div className="relative aspect-square md:aspect-auto md:min-h-[520px] bg-slate-100">
            <img src={product.image} alt={product.name} className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute left-4 top-4 rounded-full glass px-3 py-1 font-mono text-[0.6rem] uppercase tracking-widest text-[var(--navy)]">{product.sku}</div>
          </div>
          <div className="p-7 md:p-10 max-h-[80vh] overflow-y-auto" data-lenis-prevent>
            <p className="eyebrow mb-4">{product.surface_label} Surface</p>
            <DialogTitle className="font-display text-3xl font-medium tracking-tight text-[var(--navy)]" data-testid="product-modal-title">{product.name}</DialogTitle>
            <DialogDescription className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{product.description}</DialogDescription>
            <div className="mt-6">
              <Spec k="Size" v={product.size_label} />
              <Spec k="Thickness" v={`${product.thickness_mm} mm`} />
              <Spec k="Body" v={product.body} />
              <Spec k="Finish" v={product.surface_label} />
              <Spec k="Tone" v={product.tone} />
              <Spec k="Pieces / box" v={product.pcs_per_box} />
              <Spec k="Coverage / box" v={`${product.sqm_per_box} m²`} />
              <Spec k="Water absorption" v={product.water_absorption} />
            </div>
            <div className="mt-5 flex flex-wrap gap-2">
              {product.space_labels.map((s) => <span key={s} className="chip !py-1 !px-3 text-xs">{s}</span>)}
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/#contact" state={{ product: product.slug, surface: product.surface_label }} onClick={onClose} data-testid="product-modal-quote-btn" className="btn-pill btn-navy text-xs">Request quote for this tile <ArrowUpRight size={14} className="arrow" /></Link>
              <button type="button" data-testid="product-modal-spec-btn" onClick={() => toast.info("Spec sheet PDF will be available once catalogues are uploaded.")} className="btn-pill btn-ghost text-xs"><Download size={14} /> Spec sheet</button>
            </div>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
